import React, { useState, useEffect } from "react";
import WhatsAppIcon from "@/components/icons/WhatsAppIcon";
import { X, Users, MessageCircle } from "lucide-react";

const PHONE = "393773660476"; // +39 377 366 0476
const PHONE_DISPLAY = "+39 377 366 0476";
const COMMUNITY_URL = "https://chat.whatsapp.com/BYtWElK92VpIFAHOAd1H4X";
const DIRECT_URL = `https://wa.me/${PHONE}?text=${encodeURIComponent(
  "Ciao Michele, ho visto il sito di Metodo di Mare e vorrei avere informazioni."
)}`;

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-[60] flex flex-col items-end gap-3"
      data-testid="whatsapp-float-root"
    >
      {open && (
        <div className="bg-[#F9F8F6] border border-[#0B192C] shadow-[0_20px_50px_-15px_rgba(11,25,44,0.4)] w-[300px] sm:w-[340px] overflow-hidden">
          <div className="bg-[#0B192C] text-[#F9F8F6] px-5 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-[#25D366] flex items-center justify-center">
                <WhatsAppIcon size={20} className="text-white" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-[0.18em] text-[#D4B895]">
                  Contatto diretto
                </p>
                <p className="font-serif-display text-base mt-0.5">
                  Michele Roccaro
                </p>
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="whatsapp-float-close"
              aria-label="Chiudi"
              className="text-[#F9F8F6]/70 hover:text-[#F9F8F6]"
            >
              <X size={16} />
            </button>
          </div>

          <div className="p-5 space-y-3">
            <p className="text-sm font-light text-[#3A4F6B] leading-relaxed">
              Scrivimi su WhatsApp per informazioni sul libro e sui percorsi
              formativi.
            </p>

            <a
              href={DIRECT_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-direct-link"
              className="group flex items-center gap-3 w-full px-4 py-3 bg-[#0B192C] text-[#F9F8F6] text-xs uppercase tracking-[0.18em] hover:bg-[#1E3557] transition-colors"
            >
              <MessageCircle size={14} />
              <span className="flex-1 text-left">Scrivi a {PHONE_DISPLAY}</span>
            </a>

            <a
              href={COMMUNITY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-community-link"
              className="group flex items-center gap-3 w-full px-4 py-3 bg-[#D4B895] text-[#0B192C] text-xs uppercase tracking-[0.18em] hover:bg-[#0B192C] hover:text-[#F9F8F6] transition-colors"
            >
              <Users size={14} />
              <span className="flex-1 text-left">
                Entra nella Community
              </span>
            </a>

            <p className="text-[10px] uppercase tracking-[0.18em] text-[#3A4F6B] pt-2 border-t border-[#E5E1DA] mt-2">
              Community privata Metodo di Mare
            </p>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        data-testid="whatsapp-float-toggle"
        aria-label="Apri WhatsApp"
        className="group relative w-14 h-14 bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-[0_15px_40px_-10px_rgba(37,211,102,0.6)] flex items-center justify-center transition-all hover:scale-105"
      >
        {open ? <X size={22} /> : <WhatsAppIcon size={26} />}
        {!open && (
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#D4B895] border-2 border-[#F9F8F6] rounded-full animate-pulse" />
        )}
      </button>
    </div>
  );
}
